import { motion } from "framer-motion";
import { CEMENT_BRANDS } from "@/data";

export default function Brands() {
  return (
    <section data-testid="brands" className="bg-[#F5F4EF] text-black pb-28 md:pb-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="border-t border-black/15 pt-6 mb-10"
        >
          <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary">
            / Trusted cement
          </span>
          <h3 className="font-display mt-5 text-3xl md:text-5xl tracking-tighter max-w-3xl leading-[0.95]">
            We batch only with <span className="bg-signal-yellow px-2">branded cement.</span>
          </h3>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-l border-t border-black/15">
          {CEMENT_BRANDS.map((b, i) => (
            <motion.div
              key={b}
              data-testid={`brand-${b.toLowerCase()}`}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="border-r border-b border-black/15 px-6 py-10 flex items-center justify-center hover:bg-black hover:text-[#F5F4EF] transition-colors"
            >
              <span className="font-display text-2xl md:text-3xl tracking-tight">{b}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
